const validateTelephone = phone => {
  const cleanedPhone = phone.replace(/\D/g, '');

  return /^(\+\d{1,2})?(\()?(\d{3})(\))?[-.\s]?(\d{3})[-.\s]?(\d{4})$/.test(cleanedPhone);
};

export default validateTelephone;
